module.exports = __webpack_public_path__ + "img/NewDashboard.2ae84b35.png";